import styled from "styled-components";

export const StyledTabsListContainer = styled.div`
    padding-top: 10px;
    .styled-tab {
        width: fit-content;
    }
`;
